import React, { ChangeEvent, MouseEvent } from "react";
import styled, { css } from "styled-components";
import { ConfirmBtnProps, SConfirmBtnContainer } from "./ConfirmBtn";

interface FileUploadBtnProps extends ConfirmBtnProps {
  onChangeEvent: (e: ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  [key: string]: any;
}

interface SFileUploadBtn extends SConfirmBtnContainer {
  btnTextColor?: string;
  disabled?: boolean;
}

export default function FileUploadBtn({
  btnText,
  btnSidePadding,
  btnHeight,
  btnColor,
  btnTextColor,
  isDisabled,
  onChangeEvent,
  accept,
}: FileUploadBtnProps) {
  return (
    <FileUploadBtnContainer>
      <Btn
        htmlFor="file"
        btnColor={btnColor}
        btnHeight={btnHeight}
        btnSidePadding={btnSidePadding}
        btnTextColor={btnTextColor}
        disabled={isDisabled ?? false}
      >
        {btnText}
      </Btn>

      <input
        type="file"
        id="file"
        style={{ display: "none" }}
        accept={accept ?? ".xls,.xlsx"}
        onChange={onChangeEvent}
        onClick={(e: MouseEvent<HTMLInputElement>) => {
          const element = e.target as HTMLInputElement;
          element.value = "";
        }}
        disabled={isDisabled ?? false}
      />
    </FileUploadBtnContainer>
  );
}

const FileUploadBtnContainer = styled.div``;

const Btn = styled.label<SFileUploadBtn>`
  cursor: pointer;
  height: ${({ btnHeight }) => btnHeight ?? 40}px;
  border-radius: 8px;
  background-color: ${({ btnColor, theme }) =>
    btnColor === "mint"
      ? theme?.buttonColor?.blueNormal
      : btnColor === "red"
      ? theme?.buttonColor?.redNormal
      : theme?.color?.white};
  padding: ${({ btnSidePadding }) => btnSidePadding ?? "0 18px"};
  display: flex;
  align-items: center;

  &:hover {
    background-color: ${({ btnColor, theme }) =>
      btnColor === "mint"
        ? theme?.buttonColor?.blueHover
        : btnColor === "red"
        ? theme?.buttonColor?.redHover
        : theme?.buttonColor?.whiteHover};
  }

  &:active {
    background-color: ${({ btnColor, theme }) =>
      btnColor === "mint"
        ? theme?.buttonColor?.bluePressed
        : btnColor === "red"
        ? theme?.buttonColor?.redPressed
        : theme?.buttonColor?.whitePressed};
  }

  ${({ disabled }) =>
    disabled
      ? css`
          background-color: ${({ theme }) => theme?.buttonColor?.blueDisabled};
          span {
            color: ${({ theme }) => theme?.color?.white} !important;
          }

          &:hover {
            cursor: not-allowed;
            background-color: ${({ theme }) =>
              theme?.buttonColor?.blueDisabled};
            span {
              color: ${({ theme }) => theme?.color?.white} !important;
            }
          }
        `
      : css``}

  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: center;
  word-break: keep-all;
  color: ${({ btnColor, theme, btnTextColor }) =>
    btnTextColor ??
    (btnColor !== "white" ? theme?.color?.white : theme?.color?.textColor)};
`;
